import { IconNames } from '@blueprintjs/icons';
import { formatDate } from '@strata/helper-functions';
import { Icon } from '@strata/react-status-icons';
import { CountUpTimer } from '@strata/react-timers';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrAfter);

interface SnoozeStatusIconProps {
    snoozeDate?: string;
    snoozeReason?: string;
    snoozeFollowUpDate?: string;
    large?: boolean;
}

export const SnoozeStatusIcon = ({
    snoozeDate = undefined,
    snoozeReason = undefined,
    snoozeFollowUpDate = undefined,
    large = false,
}: SnoozeStatusIconProps) => {
    const hasReachedFollowUpDate = dayjs().isSameOrAfter(snoozeFollowUpDate);
    return snoozeDate ? (
        <Icon
            icon={IconNames.NOTIFICATIONS_SNOOZE}
            title="snooze"
            intent={hasReachedFollowUpDate ? Icon.Intent.WARNING : Icon.Intent.DEFAULT}
            size={large ? 24 : 16}
            tooltipContent={
                <>
                    {hasReachedFollowUpDate && <div>FOLLOW-UP REMINDER</div>}
                    <div style={{ display: 'flex' }}>
                        Snoozed&nbsp;
                        {dayjs().isSame(snoozeDate, 'day') ? (
                            'Today'
                        ) : (
                            <CountUpTimer startTime={snoozeDate} />
                        )}
                    </div>
                    <div>{snoozeReason}</div>
                    <div>Reminder on {formatDate(snoozeFollowUpDate)}</div>
                </>
            }
        />
    ) : null;
};
